import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Observable} from "rxjs/Rx";

import {BtLocalService} from '../../../app/core/local-data-services/bt-local.service';
import {MeasureContextService} from '../../../app/core/measure-context.service';
import {MeasureInputService} from '../../../app/core/measure-input.service';
import {PKLocalService} from '../../../app/core/local-data-services/pk-local.service';
import {Line, Measure, MeasureContext, PK, Potential, Way} from '../../../app/models/models';

@Component({
  selector: 'location',
  templateUrl: 'location.html'
})
export class Location implements OnInit, AfterViewInit {
  lines: Line[];
  measure: Measure;
  measureContext: MeasureContext;
  pk: PK;
  potentials: Object[] = [];
  previousPk: PK;
  ways: Object[] = [];
  updateAlready: boolean;
  @ViewChild("f") form;

  constructor(private pkLocalService: PKLocalService,
              private measureContextService: MeasureContextService,
              private measureInputService: MeasureInputService) {

    this.init();
  }

  ngAfterViewInit() {
    this.form.valueChanges
      .subscribe(() => {
        if (this.pk.hasCompleteLocation() && BtLocalService.getBT()) {
          this.updatePk();
        }
      });
  }

  ngOnInit() {
    this.measureInputService.measureContextUpdated$.subscribe(
      (measureContext: MeasureContext) => this.measureContext = measureContext || new MeasureContext()
    );
    this.measureInputService.currentMeasureUpdated$.subscribe(
      (measure: Measure) => this.measure = measure
    );
    this.measureInputService.currentPkUpdated$.subscribe(
      (pk: PK) => {
        if (this.pk.number != pk.number) {
          this.pk = Object.assign(new PK(), pk);
        }
      }
    );
    this.measureInputService.previousPkUpdated$.subscribe(
      (previousPk: PK) => this.previousPk = previousPk
    );
  }

  searchPks = (keyword: string): Observable<number[]> => {
    if (this.measure.isSpecific) {
      return this.pkLocalService.findNumbersStartingByPKNumber(keyword, 30);
    } else {
      return this.pkLocalService.findNumbersMultipleOf5StartingByPKNumber(keyword, 30);
    }
  };

  setLine(newId) {
    this.pk.line = this.lines.find(
      line => line.id === newId
    ) || new Line();
  }

  private init() {
    this.measure = MeasureInputService.getCurrentMeasure();
    this.measureContext = MeasureInputService.getMeasureContext();
    this.pk = MeasureInputService.getCurrentPk();
    this.previousPk = MeasureInputService.getPreviousPk();
    this.lines = [
      new Line(1, '1'),
      new Line(2, '2 SUD'),
      new Line(3, '2 NORD')
    ];

    let enums = JSON.parse(localStorage.getItem('enums'));
    if (enums) {
      enums['Way'].forEach(
        way => this.ways.push(new Way(way))
      );
      enums['Potential'].forEach(
        potential => this.potentials.push(new Potential(potential))
      );
    }
  }

  private updatePk() {
    if(!this.updateAlready) {
      this.updateAlready = true;
      this.pkLocalService.findByNumberAndLocation(this.pk).subscribe(
        (pk: PK) => {
          if (this.measure.isSpecific) {
            this.measureInputService.updateCurrentPk(pk.hasCompleteLocation() ? pk : new PK().setNonexistent(true), this.pk.line)
          } else {
            this.measureInputService.updateCurrentPk(pk.hasCompleteLocation() ? pk : new PK().setNonexistent(true))
          }
          this.updateAlready = false;
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/measure-input/location/location.ts